// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q5c9","content":"styles_content__3oreh","row":"styles_row__ePQ-W","footer":"styles_footer__1GT9m","phraseLength":"styles_phraseLength__snTNx"};